import type { TabDef } from "./types";

/**
 * Sistema OPERACIONAL (app do colaborador de campo).
 *
 * Funções voltadas ao próprio colaborador:
 *   - Minha Agenda: escala do colaborador logado (fixa no App, não é TAB).
 *   - Trafos em Reforma: entrada e etapas do trafo na oficina (tela própria).
 *   - Inspeção de Veículos: checklist pré-uso (tela própria).
 *   - Solicitar Folga: pedido com trava de 2 dias (tela própria).
 *   - Documentos dos Veículos: consulta dos documentos anexados na Gestão da
 *     Operação (todos os usuários veem — ver canView no App).
 *
 * Compartilha o banco do Planejamento (sercamp_planejamento) com a Gestão da
 * Operação — mesmas tabelas de agenda, folgas e inspeções.
 */
export const TABS: TabDef[] = [
  {
    // CONTROLE DE TRAFO EM REFORMA — o trafo que chega à oficina, etapa por
    // etapa (entrada → placa e serviços → ensaios e óleo → serviços →
    // Qualidade). Aberta a TODOS os usuários (ver canView no App): na oficina
    // cada um pega o trafo na etapa em que ele está. A Gestão da Operação
    // acompanha tudo ao vivo na aba "Controle de Trafos".
    key: "trafos_reforma",
    label: "Trafos em Reforma",
    icon: "trafo",
    resource: "trafos",
    subtitle:
      "Registre a entrada do trafo e avance cada etapa: placa e serviços, ensaios e coleta de óleo, andamento dos serviços e inspeção final da Qualidade.",
    custom: "trafos_reforma",
    fields: [],
  },
  {
    key: "inspecao_veiculo",
    label: "Inspeção de Veículos",
    icon: "clipboard",
    resource: "inspecoes",
    subtitle:
      "Checklist de inspeção pré-uso do veículo — responda cada pergunta (Conformidade / Não conformidade / Não se aplica) e preencha o registro em caso de não conformidade.",
    custom: "inspecao_veiculo",
    fields: [],
  },
  {
    key: "documentos_veiculos",
    label: "Documentos dos Veículos",
    icon: "file",
    resource: "documentos_veiculos",
    subtitle:
      "Documentos de cada veículo da frota (CRLV, seguro, IPVA...) — veja na tela ou baixe. Quem anexa é a Gestão da Operação.",
    custom: "documentos_veiculos",
    fields: [],
  },
  {
    key: "solicitar_folga",
    label: "Solicitar Folga",
    icon: "clock",
    resource: "folgas",
    subtitle:
      "Peça sua folga: escolha a data (somente a partir de 2 dias à frente) e o motivo. A solicitação entra como PENDENTE e o gestor aprova.",
    custom: "solicitar_folga",
    fields: [],
  },
  {
    /* Aba de todos os sistemas: o pedido cai na fila do Desenvolvimento. */
    key: "solicitar_atualizacao",
    label: "Solicitar Atualização",
    icon: "wrench",
    resource: "solicitar_atualizacao",
    subtitle:
      "Marque uma reunião com o Desenvolvimento, peça um ajuste ou avise um erro. O pedido vai direto para quem cuida dos sistemas, com o seu nome e a data.",
    fields: [],
  },
];

/**
 * Itens de MENU que podem ser liberados/bloqueados por usuário. "Agenda" não
 * está em TABS (é fixa no App), por isso entra aqui manualmente.
 */
export const MENU_PERMISSOES: { key: string; label: string }[] = [
  { key: "agenda", label: "Minha Agenda" },
  ...TABS.map((t) => ({ key: t.key, label: t.label })),
];

/** Todas as chaves de permissão (usado para "sem restrição" = tudo marcado). */
export const TODAS_PERMISSOES: string[] = MENU_PERMISSOES.map((m) => m.key);

/** Permissões padrão de um NOVO usuário colaborador — vê as 3 funções. */
export const PERMISSOES_COLABORADOR: string[] = ["agenda", "inspecao_veiculo", "solicitar_folga"];

/** Respostas possíveis de cada pergunta da inspeção. */
export const INSPECAO_RESPOSTAS: string[] = ["Conformidade", "Não conformidade", "Não se aplica"];

/**
 * Perguntas da inspeção pré-uso do veículo (padrão SERCAMP). Cada pergunta é
 * respondida com INSPECAO_RESPOSTAS + um "registro complementar" (obrigatório
 * quando a resposta for "Não conformidade").
 */
export const CHECKLIST_VEICULO: string[] = [
  "Cinto de segurança está conforme?",
  "Buzina está conforme?",
  "Volante sem folga?",
  "Pedais e sistema de freio em perfeito estado de funcionamento?",
  "Os pneus dianteiros, traseiros e pneu estepe estão em bom estado de conservação?",
  "As setas dianteiras e traseiras e pisca alerta estão funcionando?",
  "Luz de ré está funcionando bem?",
  "Luzes pisca alerta estão conformes?",
  "Faróis alto e baixo estão conformes?",
  "Limpadores e esguicho de água estão funcionando?",
  "Para-brisas e espelhos retrovisores estão conformes?",
  "Para-choques estão devidamente fixados?",
  "Há triângulo, chave de roda, pneu de estepe e macaco?",
  "O veículo está sem vazamentos de óleo?",
  "Fechamento das portas está conforme?",
  "Fechamento das travas do capô e mala estão funcionando perfeitamente?",
  "Nível de óleo do motor estão conforme?",
  "Documentação do veículo e do condutor estão conformes?",
];
